import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _extends from 'babel-runtime/helpers/extends';

import { createPopper } from '@popperjs/core';

export default {
  props: {
    popoverProps: {
      type: Object,
      // see: https://popper.js.org/documentation.html
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      instance: null
    };
  },
  mounted: function mounted() {
    var _$refs = this.$refs,
        popper = _$refs.popper,
        wrapper = _$refs.wrapper;


    var reference = wrapper.children[0] || wrapper;
    var specificRef = reference.querySelector('*[popover-reference]');

    document.body.appendChild(popper);
    this.instance = createPopper(specificRef || reference, popper, _extends({
      placement: 'right-start',
      modifiers: [{
        name: 'offset',
        options: {
          offset: [0, 8]
        }
      }]
    }, this.popoverProps));
  },
  beforeDestroy: function beforeDestroy() {
    var popper = this.$refs.popper;
    if (popper && popper.parentElement) {
      popper.parentElement.removeChild(popper);
    }

    if (this.instance) {
      this.instance.destroy();
      this.instance = null;
    }
  },

  methods: {
    show: function show() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs.popper.setAttribute('data-show', '');

        var instance = _this.instance;
        if (instance) {
          // Enable the event listeners
          instance.setOptions(function (options) {
            return _extends({}, options, {
              modifiers: [].concat(_toConsumableArray(options.modifiers), [{ name: 'eventListeners', enabled: true }])
            });
          });

          // Update its position
          instance.update();
        }
      });
    },
    hide: function hide() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs.popper.removeAttribute('data-show');

        var instance = _this2.instance;
        if (instance) {
          // Disable the event listeners
          instance.setOptions(function (options) {
            return _extends({}, options, {
              modifiers: [].concat(_toConsumableArray(options.modifiers), [{ name: 'eventListeners', enabled: false }])
            });
          });
        }
      });
    }
  }
};